"use client";

import dynamic from "next/dynamic";

const LocationMap = dynamic(
  () => import("@/components/componentsV2/location-map/LocationMap"),
  {
    ssr: false,
  }
);

export default LocationMap;